import React from "react";
import { useTranslation } from "react-i18next";
import "./footer.css";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left */}
        <div className="footer-left">
          <h4>KasCash Teknologi</h4>
          <p>{t("footer.desc")}</p>
          <div className="social-icons">
            <img
              src="/Images/youtube.svg"
              alt="YouTube"
              className="social-icon"
            />
            <img
              src="/Images/instagram.svg"
              alt="Instagram"
              className="social-icon"
            />
            <img
              src="/Images/linkedin.svg"
              alt="LinkedIn"
              className="social-icon"
            />
          </div>
        </div>

        {/* Middle intentionally empty */}
        <div className="footer-middle">
          <h4>{t("footer.location")}</h4>
          <p>{t("footer.address")}</p>
        </div>

        {/* Right: Map */}
        <div className="footer-right">

          <div className="location-content">

            <div className="map-container">
              <iframe
                title="KasCash Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.184503342951!2d107.1492211749918!3d-6.238523493753476!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e699bb4b8cc3e63%3A0xa10c799b1a78709!2sCikarang%20Utara%2C%20Bekasi%20Regency!5e0!3m2!1sen!2sid!4v1700000000000!5m2!1sen!2sid"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <p>{t("footer.copyright")}</p>
      </div>
    </footer>
  );
};

export default Footer;
